import React from "react";
import CondPayment from "../CondPayment";
import { CGE } from "../../../../common/components/CGE";

const PrivPa = ({ props }) => {

    React.useEffect(() => {
        if (props.inputSearch !== "") {
            if (props.data.find((o) => o === props.inputSearch)) {
                props.setInputSelected(props.inputSearch);
                document.getElementById("mySelectId").value = props.inputSearch;
                props.setInputSearch("");
            } else {
                props.setInputSelected("");
                document.getElementById("mySelectId").value = "";
            }
        }
    }, [props.inputSearch]);

    React.useEffect(() => {
        if (props.inputSelected) {
            props.setInputSearch("");
        } else {
            props.setInputSelected("");
            document.getElementById("mySelectId").value = "";
        }
    }, [props.inputSelected]);

    const objPropPa = {
        'webContentHtmlPa': props.webContentHtmlPa,
    }

    return (
        <div
            id="container"
            className="bg-white"
        >
            {props.showWebContentPa && <CondPayment props={objPropPa} />}
            <div className="col-md-12 d-flex align-items-center flex-column">
                <CGE.Button
                    label="Validar"
                    onClick={() => props.sendClient()}
                    type="primary"
                />
            </div>
        </div>
    );
};

export default PrivPa;